/**
 * Environment variables to prevent ANSI escape codes from being output by
 * terminal tools. Use these when spawning processes to reduce the need for
 * post-processing with stripAnsiCodes.
 */
export const DUMB_TERMINAL_ENVS = {
  NO_COLOR: "1", // Standard opt-out for colored output
  FORCE_COLOR: "0", // Ensures tools like chalk suppress color
  TERM: "dumb", // Prevents terminal formatting
} as const;

/**
 * Strips ANSI escape codes (color codes, etc.) from a string.
 * Useful for cleaning terminal output.
 */
export function stripAnsiCodes(message: string): string {
  return (
    message
      // biome-ignore lint/suspicious/noControlCharactersInRegex: we are specifically looking for control characters
      .replace(/\x1b\[[\d;]*m/g, "") // Remove color codes
      .trim()
  );
}
